import { createContext } from "react";

import { AllocationViewHelper } from "./AllocationViewHelper.ts";

export const AllocationViewContext = createContext<AllocationViewHelper>(
  {} as AllocationViewHelper
);
